import AbiLogoBig from '@assets/icons/abi-logo-big.svg'

export const Footer = () => {
  return (
    <footer className="bg-primary flex items-center justify-center gap-3 p-6" data-testid="footer-container">
      <span className="text-white">Powered by</span>
      <img src={AbiLogoBig} className="h-4" />
    </footer>
  )
}
